<template>
    <iframe :src="src" frameborder="0" width="100%" height="100%" allowfullscreen="true" allowtransparency="true" allow="microphone"></iframe>
</template>

<script>
export default {
    name: 'yihuaVideoPreview',
    data(){
        return{
            src: 'https://qt.bdbdigital.com/yihuaVideoPreview?id=oaZeu8&mode=off&sa=fyb_n_homepage&tn=top10&fr=top1000&rsv_idx=2&hisfilter=1'
        }
    }
}
</script>


<style scoped lang="scss">

</style>
